import { Box, Card } from "@mui/material";
import { useEffect, useMemo, useRef } from "react";
import ReactPlayer from "react-player";
import { uploadFile, uploadImage } from "@/services/upload";

export default function NewVideo({ file, meta, setMeta }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const handleFileChange = async () => {
    const url = await uploadFile(file);
    const cover = await createThumbnail();
    setMeta((prev) => ({ ...prev, url, cover }));
  };

  useEffect(() => {
    if (file) {
      handleFileChange();
    }
  }, [file]);

  const createThumbnail = async () => {
    await new Promise((r) => setTimeout(r, 500));

    const video = videoRef.current.getInternalPlayer();
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const coverBlob = await new Promise((resolve) => canvas.toBlob(resolve));
    const cover = await uploadImage(coverBlob);
    console.log("Thumbnail Created", cover);
    return cover;
  };

  const fileURL = useMemo(() => file && URL.createObjectURL(file), [file]);

  return (
    <Box>
      <Box
        sx={{
          px: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 4,
          mt: 2,
        }}
      >
        <Card style={{ borderRadius: "20px" }}>
          <ReactPlayer
            ref={videoRef}
            url={fileURL}
            controls
            width="100%"
            height="auto"
            onReady={createThumbnail}
          />
        </Card>
      </Box>
      <canvas ref={canvasRef} style={{ display: "none" }} />
    </Box>
  );
}
